module.exports = __webpack_public_path__ + "assets/img/es-424c7cd7.png";